import useSelector from 'modules/component/utils/hooks/useSelector'
import React from 'react'
import { logUtil } from 'packages/src'
import { useTheme } from 'modules/styles/index.js'
import getAvatarNameByIdProfileSelector from 'modules/profile/redux/selectors/get-avatar-name-by-id/index.js'
import AvatarText from 'components/AvatarText/index.js'
import { Image } from 'components/Image/index.js'

export default function ProfileImage (props) {
  logUtil('ProfileImage').debug('props=', props)
  const {
    source,
    id,
    ...rest
  } = props

  const theme = useTheme()
  const avatarSize = theme.sizes.icons.BIG
  const name = useSelector(
    getAvatarNameByIdProfileSelector(id)
  )
  const [error, setError] = React.useState()

  const handleError = (eventOrError) => {
    setError(eventOrError?.error || eventOrError)
  }

  const avatar = (
    <AvatarText
      label={name}
      size={avatarSize}
      style={{
        color: theme.colors.white,
        backgroundColor: theme.colors.black
      }}
    />
  )

  if (error) {
    return avatar
  }

  const style = {
    height: avatarSize,
    width: avatarSize,
    borderRadius: avatarSize / 2,
    objectFit: 'cover'
  }

  return (
    <>
      {
        source
          ? (
            <Image
              src={source}
              style={style}
              imgStyle={style}
              onError={handleError}
              {...rest}
            />
            )
          : avatar
      }
    </>
  )
}
